import { Skeleton } from '@/components/ui/skeleton';

export const SeriesCardSkeleton = () => (
  <div className="bg-card border border-border rounded-2xl p-5 space-y-4">
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-3">
        <Skeleton className="w-12 h-12 rounded-full bg-secondary/50" />
        <Skeleton className="h-4 w-20 bg-secondary/50" />
      </div>
      <Skeleton className="h-6 w-10 bg-secondary/50" />
      <div className="flex items-center gap-3">
        <Skeleton className="h-4 w-20 bg-secondary/50" />
        <Skeleton className="w-12 h-12 rounded-full bg-secondary/50" />
      </div>
    </div>
    <div className="flex items-center justify-between">
      <Skeleton className="h-3 w-24 bg-secondary/50" />
      <Skeleton className="h-6 w-20 rounded-full bg-secondary/50" />
    </div>
  </div>
);

export const LeaderboardSkeleton = () => (
  <div className="space-y-4">
    {[0, 1, 2].map(i => (
      <div key={i} className="bg-card border border-border rounded-2xl p-6">
        <div className="flex items-start justify-between">
          <div className="flex items-center gap-4">
            <Skeleton className="w-14 h-14 rounded bg-secondary/50" />
            <div className="space-y-2">
              <Skeleton className="h-5 w-28 bg-secondary/50" />
              <Skeleton className="h-3 w-36 bg-secondary/50" />
            </div>
          </div>
          <Skeleton className="h-10 w-16 bg-secondary/50" />
        </div>
      </div>
    ))}
    {[0, 1, 2].map(i => (
      <Skeleton key={`row-${i}`} className="h-14 rounded-xl bg-secondary/50" />
    ))}
  </div>
);

export const SeriesListSkeleton = () => (
  <div className="space-y-6">
    <Skeleton className="h-3 w-24 bg-secondary/50" />
    {[0, 1, 2, 3].map(i => (
      <SeriesCardSkeleton key={i} />
    ))}
  </div>
);
